import { ChangeDetectorRef, Component, OnInit, NgZone, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { CognitoUserInterface, AuthState } from '@aws-amplify/ui-components';
import { Auth } from 'aws-amplify';

import { AuthService, IAuthConfig } from 'src/app/core/auth';

@Component({
  selector: 'app-pagina-main-user',
  templateUrl: './pagina-main-user.component.html', 
  styleUrls: ['./pagina-main-user.component.scss']
})
export class PaginaMainUserComponent implements OnInit {

  DEBUG: boolean = false;

  user: CognitoUserInterface | undefined;
  groupName : CognitoUserInterface | undefined;
  authState: AuthState;
  arrayUser: any;

  group: string;
  entorno: string;
  flagOHC: boolean = false;
  flagGroup: boolean = false;
  flagLogKeyCloak: boolean = false;
  nombre: string;
  userId: string;

  scssUrl: string;

  constructor(
    private ref: ChangeDetectorRef, 
    private zone: NgZone, 
    private router: Router, 
    public sanitizer: DomSanitizer, 
    private authService: AuthService) { 
    if(this.router.getCurrentNavigation().extras.state == undefined){
      this.router.navigate(['/login-aws']);
    }

    // OBTENEMOS el dato pasado por navigation Usuario del cuidador
    this.group = this.router.getCurrentNavigation().extras.state.group; 
    if(this.router.getCurrentNavigation().extras.state.entorno != undefined){
      this.entorno = this.router.getCurrentNavigation().extras.state.entorno;
      if(this.entorno == "OHC"){
        //Estamos entrando por indra
        // Cargamos el estilo especifico para OHC
        // console.log("ESTILO OHC")
        this.flagOHC = true;
        this.scssUrl = '../../assets/styles/styles-ohc.scss';
      }else if (this.entorno == "LogKeyCloak"){
        this.flagLogKeyCloak = true;
      }
    }
    if(this.router.getCurrentNavigation().extras.state.arrayUser != undefined){
      this.arrayUser = this.router.getCurrentNavigation().extras.state.arrayUser; 
      this.nombre = this.arrayUser.nombre + " " + this.arrayUser.apellidos;


    }else{
      this.nombre = this.router.getCurrentNavigation().extras.state.user; 
      this.userId = this.router.getCurrentNavigation().extras.state.user; 
      this.arrayUser = {  
                          "userId":this.userId,
                          "disp1":this.userId + "A",
                          "disp2":this.userId + "B",
                          "disp3":this.userId + "C"
                        }
      // console.log(this.arrayUser);

    }

    if(this.group != "user"){
      this.flagGroup = true;
    }else{
      this.flagGroup = false;

    }

  }

  ngOnInit() {
    //Obtenemos el tipo de usuario
    Auth.currentAuthenticatedUser({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then(user => {
      this.group = user.signInUserSession.accessToken.payload["cognito:groups"][0];

    }
  ).catch(err => {
    if(this.DEBUG){
      console.log(err);
    }
  });

  if(this.group != "user"){
    this.flagGroup = true;
  }else{
    this.flagGroup = false;

  }

    if(this.DEBUG){
      console.log("[PaginaMainUserComponent]: " + this.userId);
    }



  }

  public deleteCookie(cookieName) {
    this.setCookie({ name: cookieName, value: '', expireDays: -1 });
  }
  async signOut(){
    this.authService.doLogout();
    this.deleteCookie('Pharaon_Portal_session')
    try {
      await Auth.signOut();
      // Hub.dispatch('UI Auth', {   // channel must be 'UI Auth'
      //       event: 'AuthStateChange',    // event must be 'AuthStateChange'
      //       message: 'signedout'    // message must be 'signedout'
      //   });
      if(this.DEBUG){
        console.log('signOut');
      }
      this.router.navigate(['/login-aws']);
  } catch (error) {
    if(this.DEBUG){
      console.log('error signing out: ', error);
    }
  }
  }


  back(){
    if(this.group == "caregiver" || this.group == "medical"){
      this.router.navigate(['/main-carer'], {state: {carer: this.arrayUser.carer}});  //, group: this.group
    }else if(this.group == "master"){
      this.router.navigate(['/login-aws'], {state: {carer: this.arrayUser.carer}});  
    }
    
  }

  public setCookie(params: any) {
    let d: Date = new Date();
    d.setTime(
      d.getTime() +
        (params.expireDays ? params.expireDays : 1) * 24 * 60 * 60 * 1000
    );
    document.cookie =
      (params.name ? params.name : '') +
      '=' +
      (params.value ? params.value : '') +
      ';' +
      (params.session && params.session == true
        ? ''
        : 'expires=' + d.toUTCString() + ';') +
      'path=' +
      (params.path && params.path.length > 0 ? params.path : '/') +
      ';' +
      (location.protocol === 'https:' && params.secure && params.secure == true
        ? 'secure'
        : '');
  }
}
